window.addEventListener('load', () => {
  const dropdowns = document.querySelectorAll(".localisation-dropdown-selector");
  
  function handleLocalisationChange() {
    dropdowns.forEach((dropdown) => {
      dropdown.selectedIndex = "0";
    });
  }

  handleLocalisationChange();
})

window.addEventListener("DOMContentLoaded", () => {
    let vidFullScreenBtn = document.getElementById("video-fullscreen-button");
    let productVideo = document.querySelector('.product__video');

    if (vidFullScreenBtn) {
      vidFullScreenBtn.addEventListener( "click", () => fullscreenifyProductVideo(), false );
    }

    function fullscreenifyProductVideo() {
        if (productVideo.requestFullscreen) {
          productVideo.requestFullscreen();
        } else if (productVideo.mozRequestFullScreen) { // Firefox
          productVideo.mozRequestFullScreen();
        } else if (productVideo.webkitRequestFullscreen) {// Chromium and macOS Safari
          productVideo.webkitRequestFullscreen();
        } else if (productVideo.webkitSupportsFullscreen) { // iOS Safari
          productVideo.webkitEnterFullscreen();
        }
    }
})

/*Remove Z size from Popup*/
jQuery(document).ready(function () {
    //console.log('LOAD');
    let optionRemove = false;
    jQuery('body').on('click', '.product-single__form .back-stock-btn', function () {
        //console.log('CLICK');
        if (!optionRemove) {
            jQuery('#BIS_frame').contents().find('#variants option:first-child').remove();
            optionRemove = true;
        }
    });
  
  
  if (jQuery('.slider-404').length) {
    var slickElement = jQuery('.slider-404');
    slickElement.on('init', function () {
      jQuery(this).css('visibility', 'visible');
    });
    jQuery('.slider-404').slick({
            arrows: true, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: true, /*Автопрокрутка*/
            infinite: true,
            variableWidth: false,
            fade: false,
            autoplaySpeed: 5000, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
               	{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      arrows: false
                    }
                }
            ]
        });
      }
});
jQuery(document).ready(function ($) {
  	$('.s-table-in').hide();
  	if($('.s-table-in').parent('.table-wrapper').length !== 0) {
  		$('.s-table-in').parent('.table-wrapper').hide();
    }
	$(document).on('click','.sel-cm-table,.sel-in-table',function(e){
      e.preventDefault();
      $('.sel-cm-table,.sel-in-table').removeClass('active');
      $('.s-table-cm,.s-table-in').hide();
      $('.s-table-cm,.s-table-in').parent('.table-wrapper').hide();
      if($(this).hasClass('sel-cm-table')) {
        $('.sel-cm-table').addClass('active');
        $('.s-table-cm').show();
        $('.s-table-cm').parent('.table-wrapper').show();
      }
      else if($(this).hasClass('sel-in-table')) {
        $('.sel-in-table').addClass('active');
        $('.s-table-in').show();
        $('.s-table-in').parent('.table-wrapper').show();
      }
      return false;
    });

  $(document).on('click',".mw-size-nav li a", function(e){
    e.preventDefault();
    var ctHeight = $("header").outerHeight() * 2;
    var y = document.getElementById($(this).attr("href").replace("#", "")).getBoundingClientRect().top + window.scrollY;
    var duration = 2000;//long scroll
    var duration2 = 1000;//short scroll
    if(($(this).attr("href") === "#menswear" && $(this).closest(".mw-size-nav").hasClass("mw-bottom")) || ($(this).attr("href") === "#womenswear" && !$(this).closest(".mw-size-nav").hasClass("mw-bottom"))) {
      duration = duration2;
    }
    if($(this).closest(".mw-size-nav").hasClass("mw-bottom") && $(this).attr("href") === "#menswear") {
      return false;
    }
    $("html, body").stop().animate({ scrollTop: $($(this).attr("href")).offset().top - ctHeight }, duration, "swing");
    return false;
  });

  $(document).on('change', '.cb-label [name=form_tags]', function() {
    var input = $("#ct_val");
    var newVal = "";
    input.val("");
    var index = 0;
    $(".cb-label [name=form_tags]").each(function() {
      if($(this).prop("checked")) {
        if(index !== 0) {
          newVal += ",";
        }
        newVal += $(this).val();
		index++;
      }
    });
    input.val(newVal);
  });
});
